// src/pages/AuthCallback.tsx
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { supabase } from '../services/supabase'
import '../styles/components/AuthCallback.css'

const AuthCallback: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [error, setError] = useState('')

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Check for OAuth error in URL parameters
        const error = searchParams.get('error')
        const errorDescription = searchParams.get('error_description')
        
        if (error) {
          setError(errorDescription || `Authentication error: ${error}`)
          setTimeout(() => navigate('/login'), 3000)
          return
        }

        // Get the session from URL fragments
        const { data: { session }, error: sessionError } = await supabase.auth.getSession()
        
        if (sessionError) {
          setError(sessionError.message)
          setTimeout(() => navigate('/login'), 3000)
          return
        }

        if (session) {
          // Check if user has a profile
          const { data: profile, error: profileError } = await supabase
            .from('profiles')
            .select('*')
            .eq('id', session.user.id)
            .single()

          if (profileError || !profile) {
            navigate('/profile')
          } else {
            navigate('/dashboard')
          }
        } else {
          setError('No session found. Please try signing in again.')
          setTimeout(() => navigate('/login'), 3000)
        }
      } catch (error: any) {
        console.error('Auth callback error:', error)
        setError(error.message || 'An unexpected error occurred')
        setTimeout(() => navigate('/login'), 3000)
      }
    }

    handleAuthCallback()
  }, [navigate, searchParams])

  if (error) {
    return (
      <div className="auth-callback-container">
        <div className="error-message">
          <h3>Authentication Failed</h3>
          <p>{error}</p>
          <p>Redirecting to login...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="auth-callback-container">
      <div className="loading-spinner"></div>
      <p>Completing sign in...</p>
    </div>
  )
}

export default AuthCallback